import React, { useState } from 'react';
import './schedule_appointment_modal.scss';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function Disclaimer({ syncCardData, phone }) {
  const [ccAgree, setAgree] = useState(false);
  const { t } = useTranslation();

  function handleAgreeChange() {
    setAgree(!ccAgree);
    syncCardData({
      ccAgree: !ccAgree,
    });
  }

  return (
    <div>
      <form id="paymentForm">
        <div>
          <p>
            {t(
              'By entering your credit card information, you are giving permission to our dental practice to securely store your credit card information on file.',
            )}
          </p>
          <p>
            {t('If you have any questions, please call our practice at')} {phone}.
          </p>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            onChange={handleAgreeChange}
            id="defaultCheck1"
            required
          />
          <label className="form-check-label" htmlFor="defaultCheck1">
            {t('I understand')}
          </label>
        </div>
      </form>
    </div>
  );
}

Disclaimer.propTypes = {
  syncCardData: PropTypes.func,
  phone: PropTypes.string,
};

export default Disclaimer;
